import type { EmptyResponse } from '@/types/responseModel';
import type { TaskData, TaskListRequest } from '@/types/task';
import { Request } from '@/utils/request';
import type { CommonResponse } from '@/utils/request';

export function getTaskList(data: TaskListRequest) {
  return Request<CommonResponse<{ list: TaskData[]; total: number }>>({
    url: '/rest/general/user/task/list',
    method: 'post',
    data
  });
}

export function deleteTask(data: { id?: number; mindId: string; sessionId: string }) {
  return Request<EmptyResponse>({
    url: '/rest/general/user/task/delete',
    method: 'post',
    data
  });
}

export function updateTaskName(data: { sessionId: string; userTitle: string }) {
  return Request<EmptyResponse>({
    url: '/rest/general/user/task/rename',
    method: 'post',
    data
  });
}

export function getCreated(mindId: string) {
  return Request<EmptyResponse>({
    url: '/rest/general/user/task/count/unread/created',
    method: 'get',
    params: {
      mindId
    }
  });
}

export function getCompleted(mindId: string) {
  return Request<EmptyResponse>({
    url: '/rest/general/user/task/count/unread/completed',
    method: 'get',
    params: {
      mindId
    }
  });
}

export function readAllTask(mindId: string) {
  return Request<EmptyResponse>({
    url: '/rest/general/user/task/read/all',
    method: 'post',
    data: {
      mindId
    }
  });
}

export function getTaskName(sessionId: string) {
  return Request<EmptyResponse>({
    url: '/rest/general/user/task/get/name',
    method: 'get',
    params: {
      sessionId
    }
  });
}
